module.exports = __webpack_public_path__ + "ac602a4fad93afe0cedaea85661df768.png";